export function localeFormat(inputNumber: number, fixedSigns = 0): string {
  return Number(inputNumber.toFixed(fixedSigns)).toLocaleString();
}
